<template>
  <v-app
    class="grey lighten-4"
    style="max-height: 100vh"
    v-if="SO_API_BASE_URL != null"
    :key="updateCounter"
  >
    <license-notification />
    <NavBar
      v-if="
        $router.currentRoute.name !== 'home' &&
        currentUser.role != 'PublicDashboard'
      "
    />

    <v-main
      v-bind:class="{
        sientificLight: !this.darkmode && userSettings.theme != 'Colors',
        sientificDark: this.darkmode && userSettings.theme != 'Colors',
        backg: userSettings.theme == 'Colors' && !this.darkmode,
        backgdark: userSettings.theme == 'Colors' && this.darkmode,
      }"
      style="padding: 0"
    >
      <router-view></router-view>
    </v-main>

    <v-snackbar
      v-model="refresh"
      v-if="message != ''"
      bottom
      right
      :timeout="3000"
      :color="alertType == 'error' ? 'red' : 'green'"
      >{{ message }}
    </v-snackbar>

    <v-footer app v-if="$router.currentRoute.name === 'dashboardChooser'">
      <span>
        {{
          this.globalSettings.powered_by
            ? this.globalSettings.powered_by
            : "Nodeledge AB"
        }}</span
      >
    </v-footer>

    <!-- <data-hub v-if="permitted('Tag.View')" /> -->
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import { Roles } from "@/_helpers/Role";
import LicenseNotification from "./components/license/LicenseNotification.vue";
import eventListeningMixin from "./_helpers/eventListeningMixin";
import msal from "@/msal";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "App",
  components: {
    NavBar,
    LicenseNotification,
  },

  mixins: [eventListeningMixin],

  data() {
    return {
      refresh: false,
      landing: false,
    };
  },

  updated() {
    if (this.$router.currentRoute.name == "home") {
      this.landing = true;
    }

    document.title = this.documentTitle;
  },

  async created() {
    this.$vuetify.theme.dark = this.darkmode;
    await this.getBaseUrl();
    await this.getFrontendFeatures();
    await this.getGlobalSettings();
    if (this.ssoAvailable) {
      await msal.setup();
    }

    if (this.status.loggedIn && this.currentUser.role != "PublicDashboard") {
      await this.getUserSettings();
      await this.getCompanySettings();
      await this.getCompanyFeatures();
    }

    document.title = this.documentTitle;

    if (this.whiteLabel) {
      const favi = document.getElementById("favicon");
      favi.href = window.location.origin + "/so-white-label-favicon.ico";
    }

    this.clearAlert();
  },

  computed: {
    ...mapGetters("users", ["companyId"]),
    ...mapState("alert", ["active", "message", "alertType"]),
    ...mapState("configuration", [
      "darkmode",
      "userSettings",
      "globalSettings",
    ]),
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "updateCounter",
    ]),
    ...mapGetters("configuration", ["documentTitle", "ssoAvailable"]),

    Roles() {
      return Roles;
    },
  },
  methods: {
    ...mapActions("featureAccess", ["getCompanyFeatures"]),
    ...mapActions({ clearAlert: "alert/clear" }),
    ...mapActions("configuration", [
      "getFrontendFeatures",
      "getGlobalSettings",
      "getUserSettings",
      "getCompanySettings",
      "getBaseUrl",
      "SO_API_BASE_URL",
    ]),
  },

  watch: {
    message(val) {
      if (val) {
        this.refresh = true;
      } else {
        this.refresh = false;
      }
    },

    refresh(value) {
      if (value === false) this.clearAlert();
    },
  },
};
</script>

<style>
.backg {
  /* background: rgb(235, 235, 235); */
  background-image: url("/bg.jpg");
  background-size: cover;
}

.backgdark {
  background-image: url("/bgdark.jpg");
  background-size: cover;
}

.sientificLight {
  background-color: #e9e9e9;
}

.sientificDark {
  background-color: #121212;
}
</style>
